var AdaptiveImage = require( "../../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/badge_new.fc224821.png",
    width: 180,
    height: 90
});